/* Header state machine, every page. Rhode runs three states (8-29, read off
 * their own stylesheet: .Header.transparent / .Header__hidden = -150% /
 * .Header__sticky): clear over the home hero at the top of the page, slid
 * off the screen while scrolling DOWN, solid and pinned the moment you
 * scroll UP. The clear state only ever applies where the page carries the
 * hero's data-home-clear-header flag; everywhere else the top-of-page state
 * is simply the solid bar. Loaded from sections/duet-header.liquid (a bare
 * inline <script> in a Horizon section does not run reliably).
 *
 * Horizon scrolls .page-wrapper on the desktop and the document on a phone;
 * the capturing listener hears both. d2-home.js used to own the clear flip —
 * that block is retired so exactly one script drives the classes.
 */
(function () {
  'use strict';

  var header = document.querySelector('.duet-header');
  if (!header) return;

  var clearFlag = !!document.querySelector('[data-home-clear-header]');
  var wrapper = document.querySelector('.page-wrapper');
  var lastTop = 0;
  var ticking = false;

  function top() {
    var doc = document.scrollingElement || document.documentElement;
    return Math.max(doc.scrollTop, wrapper ? wrapper.scrollTop : 0);
  }

  function update() {
    ticking = false;
    var t = top();
    /* 2px of hysteresis so momentum jitter cannot flap the bar */
    var down = t > lastTop + 2;
    var up = t < lastTop - 2;

    if (t <= 8) {
      header.classList.remove('duet-header--hidden');
      header.classList.toggle('duet-header--clear', clearFlag);
    } else {
      header.classList.remove('duet-header--clear');
      /* 120 ≈ one bar height: no hide while the hero has barely moved */
      if (down && t > 120) {
        header.classList.add('duet-header--hidden');
      } else if (up) {
        header.classList.remove('duet-header--hidden');
      }
    }

    if (down || up) lastTop = t;
  }

  document.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { capture: true, passive: true }
  );

  update();
})();
